<div *ngIf="getConfigIsReady$ | async" class="settings-container">
  <div class="form-container" [formGroup]="configForm">
    <mat-card appearance="outlined">
      <mat-card-content formGroupName="orderSetupConfig">
        <div class="steps">
          <mat-checkbox formControlName="hideSalesOrders">
            {{ 'SALES_ORDER_CONFIG_SETUP.HIDE_SALES_ORDERS' | translate }}
          </mat-checkbox>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="save">
    <ng-container *ngIf="saveConfigIsLoading$ | async; else submitButton">
      <div class="spinner">
        <mat-spinner class="button-spinner" [diameter]="24" [strokeWidth]="3"></mat-spinner>
      </div>
    </ng-container>
    <ng-template #submitButton>
      <button mat-raised-button color="primary" (click)="saveConfig()">
        {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
      </button>
    </ng-template>
  </div>
</div>
